module.exports = __webpack_public_path__ + "static/wawa-018f8d42686308ea693f6369e266dd65.mp3";